import React from 'react';
export const SettingsContext = React.createContext<any>(null);
